export default __webpack_public_path__ + "7ccdd1fe4e9dc22e7989e36e9bc1c098.webp";